import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@web-chat-core/ui-kit';
import { ERROR_TYPE } from 'consts';
import { ErrorContent, ErrorWrapper } from './view';

interface Props {
    errorType?: ERROR_TYPE;
}

export const Error: React.FC<Props> = ({ errorType }) => {
    const { t } = useTranslation();

    let content: React.ReactNode;

    switch (errorType) {
        case ERROR_TYPE.VCS_P2P_JOIN_BY_LINK_OPERATION_NOT_SUPPORTED:
            content = (
                <ErrorContent>
                    <Typography variant="body3">{t('web_call_connect_people')}</Typography>
                    <br />
                    <Typography variant="body3">{t('web_call_group_call_create_link')}</Typography>
                </ErrorContent>
            );
            break;

        default:
            content = (
                <ErrorContent>
                    <Typography variant="body3">{t('web_call_incorrect_link')}</Typography>
                    <br />
                    <Typography variant="body3">{t('web_call_problemst_arisen')}</Typography>

                    <ul>
                        <li>
                            <Typography variant="body3">{t('web_call_room_id_link')}</Typography>
                        </li>
                        <li>
                            <Typography variant="body3">
                                {t('web_call_token_url', { 0: process.env.REACT_APP_PRODUCT_NAME })}
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body3">{t('web_call_link_incorrect')}</Typography>
                        </li>
                        <li>
                            <Typography variant="body3">{t('web_call_launched_development')}</Typography>
                        </li>
                    </ul>
                </ErrorContent>
            );
    }

    return <ErrorWrapper>{content}</ErrorWrapper>;
};
